import { DownwardOutlineIcon, UpwardOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextCaption } from '@carboncopyco/ui';
import { useConsoleState } from './ConsoleContext';

type TrendLabelProps = { trend: number | null };

export const TrendLabel = ({ trend }: TrendLabelProps) => {
  const { period } = useConsoleState();
  const trendLabel =
    trend === null
      ? 'No activity in the previous period'
      : trend === 0
        ? `No change from previous ${period} days`
        : 'from last period';
  const isNegative = trend && trend < 0;

  return (
    <div className="flex items-center gap-1">
      {trend != null && (
        <div className="flex items-center gap-1">
          {isNegative ? (
            <DownwardOutlineIcon
              size={12}
              color={ColorHex.danger300}
            />
          ) : (
            <UpwardOutlineIcon
              size={12}
              color={ColorHex.accent2400}
            />
          )}
          <TextCaption
            label={`${String(trend)}%`}
            color={isNegative ? 'text-ds-danger-300' : 'text-ds-accent2-400'}
          />
        </div>
      )}
      <TextCaption
        label={trendLabel}
        color="text-ds-natural-300"
      />
    </div>
  );
};
